import { $t } from '@/i18n';
import Cookies from 'js-cookie';
import antdCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { cloneDeep } from 'lodash';
const standardLangMap = cloneDeep(window.langController.langMap);
export const getLanguage = () => window.langController.getLang();
export const writeLanguageConfig = (lang) => {
    const finalLang = standardLangMap[lang];
    if (!finalLang) {
        console.error($t('k_e40ed065', { arg_0: lang, arg_1: Object.keys(standardLangMap).join(',') }));
        return;
    }
    Cookies.set('lang', finalLang);
};
const getLanguageConfig = async (withTdesign) => {
    const lang = getLanguage();
    const languageMap = {
        tdesign: {
            [standardLangMap.en]: () => import('tdesign-vue/es/locale/en_US'), // en and en_US share the same locale
            [standardLangMap.cn]: async () => ({ default: null }), // td 默认的就是 cn，不需要 import
        },
        antd: {
            [standardLangMap.en]: () => import('ant-design-vue/lib/locale-provider/en_US'),
            [standardLangMap.cn]: async () => ({ default: antdCN }),
        },
    };
    const loadPromise = [languageMap.antd[lang]?.()];
    if (withTdesign) {
        loadPromise.push(languageMap.tdesign[lang]?.());
    }
    const [antdLocale, tdesignLocale] = await Promise.all(loadPromise);
    return {
        antdLocale: antdLocale?.default,
        tdesignLocale: tdesignLocale?.default,
    };
};
export default getLanguageConfig;
